import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Action from '../action';
import { messages } from '../../../../../messages';
import { FormattedMessage } from 'react-intl-next';
import EditIcon from '@atlaskit/icon/glyph/edit';
const EditAction = props => /*#__PURE__*/React.createElement(Action, _extends({
  content: /*#__PURE__*/React.createElement(FormattedMessage, messages.edit)
  // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
  ,
  icon: /*#__PURE__*/React.createElement(EditIcon, {
    label: "Edit"
  }),
  testId: "smart-action-edit-action",
  tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, messages.edit)
}, props));
export default EditAction;